<div class="nav-container mobile-system-bar-inset" data-cy="nav-container">
  @if (navState().ShowNav && pageLabels()) {
    <nav class="nav-bar" data-cy="nav-bar">
      <div class="nav-content-container">
        <div class="logo">
          @if (navState().Logo.Show) {
            <a [routerLink]="navState().Logo.Url" data-cy="nav-logo-link">
              <img class="gs-logo" [src]="pageLabels()!.gsLogoUrl" [alt]="navState().Logo.Aria" />
            </a>
          }
        </div>
        <div class="menu-options">
          @if (!isMobile()) {
            @if (navState().Home.Show) {
              <a
                class="menu-option"
                mat-flat-button
                [attr.aria-label]="navState().Home.Aria"
                [routerLink]="navState().Home.Url"
                data-cy="nav-home-link"
                >{{ pageLabels()!.homeMenuLabel }}</a
              >
            }
            @if (navState().Billing.Show) {
              <button
                [class.active]="billingMenuOpen()"
                class="menu-option"
                mat-flat-button
                disableRipple="true"
                [matMenuTriggerFor]="bMenu"
                (menuOpened)="billingMenuOpen.set(true)"
                (menuClosed)="billingMenuOpen.set(false)"
                data-cy="nav-billing-menu-trigger"
              >
                {{ pageLabels()!.billingAndPaymentsMenuLabel }}
              </button>
            }
            @if (navState().Manage.Show) {
              <button
                [class.active]="manageMenuOpen()"
                class="menu-option"
                mat-flat-button
                disableRipple="true"
                [matMenuTriggerFor]="mMenu"
                (menuOpened)="manageMenuOpen.set(true)"
                (menuClosed)="manageMenuOpen.set(false)"
                data-cy="nav-manage-menu-trigger"
              >
                {{ pageLabels()!.manageAccountMenuLabel }}
              </button>
            }
            @if (navState().Perks.Show) {
              <a
                class="menu-option"
                mat-flat-button
                [attr.aria-label]="navState().Perks.Aria"
                [routerLink]="navState().Perks.Url"
                data-cy="nav-perks-link"
                >{{ pageLabels()!.advantagePerksMenuLabel }}</a
              >
            }
          }
        </div>
        <div class="logout login">
          @if (navState().PayBill.Show && !isMobile()) {
            <a
              [routerLink]="navState().PayBill.Url"
              [attr.aria-label]="navState().PayBill.Aria"
              data-cy="nav-pay-bill-link"
              >{{ pageLabels()!.paymentMenuLabel }}</a
            >
          }
          @if (navState().Logout) {
            <button
              id="btnLogout"
              mat-button
              (click)="logout()"
              class="logout-button"
              [attr.aria-label]="pageLabels()!.logoutText"
              data-cy="btn-logout"
            >
              <i class="fa-regular fa-arrow-right-from-bracket fa-2x" aria-hidden="true"></i>
            </button>
          }
          @if (navState().Login) {
            <button id="btnLogin" mat-button (click)="logout()" class="login-button" data-cy="btn-login">
              <i class="fa fa-sign-in fa-2x" aria-hidden="true"></i>
              {{ pageLabels()!.loginText }}
            </button>
          }
        </div>
      </div>
    </nav>

    <mat-menu #bMenu="matMenu" class="header-menu menu-panel" id="BillingMenuPanel" panelClass="header-menu-panel">
      <div class="whole-menu">
        <div class="menu-left">
          @for (item of getBillingMenuOptions(0); track item.menuOption.id ?? $index) {
            @if (showMenuOption(item.menuOption.id)) {
              <a
                mat-menu-item
                [attr.aria-label]="item.menuOption.ariaLabel"
                [routerLink]="item.menuOption.url.url"
                [attr.data-cy]="'nav-billing-' + item.menuOption.id"
                >{{ item.menuOption.displayText }}</a
              >
            }
          }
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div class="menu-right">
          @for (item of getBillingMenuOptions(1); track item.menuOption.id ?? $index) {
            @if (showMenuOption(item.menuOption.id)) {
              <a
                mat-menu-item
                [attr.aria-label]="item.menuOption.ariaLabel"
                [routerLink]="item.menuOption.url.url"
                [attr.data-cy]="'nav-billing-' + item.menuOption.id"
                >{{ item.menuOption.displayText }}</a
              >
            }
          }
        </div>
      </div>
    </mat-menu>

    <mat-menu #mMenu="matMenu" class="header-menu menu-panel" id="ManageMenuPanel" panelClass="header-menu-panel">
      <div class="whole-menu">
        <div class="menu-left">
          @for (item of getManageMenuOptions(0); track item.menuOption.id ?? $index) {
            @if (showMenuOption(item.menuOption.id)) {
              <a
                mat-menu-item
                [attr.aria-label]="item.menuOption.ariaLabel"
                [routerLink]="item.menuOption.url.url"
                [attr.data-cy]="'nav-manage-' + item.menuOption.id"
                >{{ item.menuOption.displayText }}</a
              >
            }
          }
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div class="menu-right">
          @for (item of getManageMenuOptions(1); track item.menuOption.id ?? $index) {
            @if (showMenuOption(item.menuOption.id)) {
              <a
                mat-menu-item
                [attr.aria-label]="item.menuOption.ariaLabel"
                [routerLink]="item.menuOption.url.url"
                [attr.data-cy]="'nav-manage-' + item.menuOption.id"
                >{{ item.menuOption.displayText }}</a
              >
            }
          }
        </div>
      </div>
    </mat-menu>
  }
</div>
